import createCache from "@emotion/cache";

// Shared Emotion cache for client + server, to ensure consistent classnames and SSR extraction.
export default function createEmotionCache() {
  return createCache({ key: "css", prepend: true });
}

